import { Alert } from '@te-whatu-ora/anatomic'

export function ItemGenericWarning() {
  return <Alert variant='critical'>Could not display item</Alert>
}
